<template>
  <v-container class="fill-height" id="invoice-online-payment-redirect">
    <v-row>
      <v-col class="text-center">
        <v-progress-circular
          :size="150"
          :width="6"
          class="mb-4"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div class="display-1">
          {{ $t("message.payment_link_will_be_started") }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "InvoiceOnlinePaymentRedirect",
  mounted() {
    if (!this.$store.state.subscription.uuid) {
      this.$router.push("/login");
      return;
    }

    this.$store
      .dispatch("subscription/subscribe")
      .then(response => {
        this.invoiceOnlinePaymentResult = response.data;
      })
      .finally(() => {
        this.$store.state.subscription.uuid = null;
      });
  },
  data() {
    return {
      invoiceOnlinePaymentResult: {}
    };
  }
};
</script>

<style scoped></style>
